import React from 'react';
import {IntegrationApiOptionsFieldV2} from "../IntegrationApiOptionsFieldV2";

interface Props {
    readonly onChange: (name:string, value: any) => void,
    readonly data: any
}

export function IntegrationApiBody({onChange,data}: Props) {
    return (
        <div>
            <IntegrationApiOptionsFieldV2 data={data.body} onChange={(value) => onChange("requestBody", value)}/>
        </div>
    );
}




